/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Collapse } from 'react-collapse';

import { getDetailedRole } from '../../common/Utils';

class Summary extends Component {
    constructor(...args) {
        super(...args);

        this.state = {
            showDetails: false,
        };
    }

    render() {
        const jobs = [].concat(this.props.jobRequest);
        let total = 0;
        let vat = 0;
        let freelancerCost = 0;
        let totalFreelancers = 0;
        let totalHours = 0;
        jobs.map((job, i) => {
            if (
                this.props.discount &&
                i <= (this.props.discount.remaining_uses || 1)
            ) {
                total += this.props.discount.discounted_price;
                vat += this.props.discount.discounted_vat;
            } else {
                total += job.client_final_cost;
                vat += job.client_vat;
            }
            totalFreelancers += job.number_of_freelancers;
            totalHours += job.duration * job.number_of_freelancers;
            freelancerCost +=
                job.client_pay_per_hour *
                job.duration *
                job.number_of_freelancers;
        });
        const recurrencePeriod = jobs[0].recurrence_period;

        return (
            <div className="summary-wrapper">
                <table
                    className={`summary-table${
                        !this.state.showDetails ? ' collapsed' : ''
                    }`}
                >
                    <tbody>
                        {jobs.map((job, index) => (
                            <tr key={index}>
                                <td className="td-left">
                                    {job.number_of_freelancers}&times;{' '}
                                    {job.service_role}{' '}
                                    {recurrencePeriod == 7
                                        ? ' every week starting '
                                        : recurrencePeriod > 0
                                        ? ` every ${recurrencePeriod} days starting `
                                        : ''}{' '}
                                    on {moment(job.date).format('DD/MM')}
                                </td>
                                <td className="td-right">
                                    {job.duration}h @ £
                                    {parseFloat(
                                        this.props.discount &&
                                            this.props.discount.flat_rate &&
                                            index <
                                                (this.props.discount
                                                    .remaining_uses || 1)
                                            ? this.props.discount.flat_rate
                                            : job.client_pay_per_hour,
                                    ).toFixed(2)}{' '}
                                    /hr
                                </td>
                            </tr>
                        ))}
                        <tr className="bold top-bordered">
                            <td className="td-left">Subtotal</td>
                            <td className="td-right">
                                £{freelancerCost.toFixed(2)}
                            </td>
                        </tr>
                        {this.props.discount &&
                        !this.props.discount.flat_rate ? (
                            <tr>
                                <td className="td-left">Voucher added</td>
                                <td className="td-right bold">
                                    –£{this.props.discount.discount.toFixed(2)}
                                </td>
                            </tr>
                        ) : null}
                        <tr>
                            <td className="td-left">
                                VAT (20% of £{(vat / 0.2).toFixed(2)})
                            </td>
                            <td className="td-right">£{vat.toFixed(2)}</td>
                        </tr>
                        <tr className="bordered bold">
                            <td className="td-left">
                                Total{' '}
                                {recurrencePeriod == 7
                                    ? 'per week'
                                    : recurrencePeriod > 0
                                    ? `per ${recurrencePeriod} days period`
                                    : ''}
                            </td>
                            <td className="td-right purple">
                                £{total.toFixed(2)}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table
                    className={`summary-table summary-table--total${
                        this.state.showDetails ? ' collapsed' : ''
                    }`}
                >
                    <tbody>
                        <tr className="bordered bold">
                            <td className="td-left">
                                {totalFreelancers} worker
                                {totalFreelancers > 1 ? 's' : ''} for{' '}
                                {totalHours} hours{' '}
                                {recurrencePeriod == 7
                                    ? 'every week'
                                    : recurrencePeriod > 0
                                    ? `every ${recurrencePeriod} days`
                                    : ''}
                            </td>
                            <td className="td-right purple">
                                £{total.toFixed(2)}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className="summary-options">
                    <a
                        className="summary-option"
                        href="#"
                        onClick={() =>
                            this.setState({
                                showDetails: !this.state.showDetails,
                            })
                        }
                    >
                        {this.state.showDetails
                            ? 'Hide details'
                            : 'More details'}
                    </a>
                    {!this.props.showVoucher ? (
                        <a
                            className="summary-option"
                            href="#"
                            onClick={this.props.toggleVoucher}
                        >
                            Use a voucher&hellip;
                        </a>
                    ) : null}
                </div>
                {this.props.showVoucher ? this.props.voucherSection : null}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        discount: state.requestData.discount,
        jobRequest: state.requestData.jobRequest,
        roleData: state.requestData.roleData,
    };
}

export default connect(mapStateToProps, {})(Summary);
